


































































import Vue from "vue";
import {
  IMilestoneForm,
  IMilestone,
} from "@/modules/milestone-planner/services/data/milestones/milestone.interface";
import { IMatchingQuestion } from "@/services/data/matching-questionary/matching-question.interface";

import moment from "moment";
import mapKeys from "lodash/mapKeys";
import camelCase from "lodash/camelCase";
import pick from "lodash/pick";

export default Vue.extend({
  name: "MilestoneFormGuestView",

  props: {
    milestone: {
      type: Object as () => IMilestone,
      default: null,
    },
    isMilestonePlanned: {
      type: Boolean,
      default: false,
    },
    isMilestoneComplete: {
      type: Boolean,
      default: false,
    },
    isPlanPublished: {
      type: Boolean,
      default: false,
    },
    isPlanTabActive: {
      type: Boolean,
      default: true,
    },
    questions: {
      type: Array as () => Array<IMatchingQuestion>,
      default: () => [],
    },
  },

  data() {
    return {
      planForm: {} as IMilestoneForm["plan"],
      completeForm: {} as any,
      planInitialState: Object.freeze({
        strategy: "",
        outcomes: "",
        resources: "",
        financesNeeded: "",
        targetDate: null,
      }) as IMilestoneForm["plan"],
      evidenceInitialState: Object.freeze({
        // TEMP: Evidence will need to be converted into an array of IMilestoneEvidence
        evidence: "",
        dateOfCompletion: null,
      }),
    };
  },

  computed: {
    showPlannerInfo(): boolean {
      return (
        (this.isPlanTabActive && this.isPlanPublished) ||
        (!this.isPlanTabActive && this.isMilestoneComplete)
      );
    },

    ownerName(): string {
      return this.$store.get("profile/company.data")?.name || "";
    },

    emptyState(): any {
      return this.isPlanTabActive
        ? this.emptyStatePlanTab
        : this.emptyStateCompleteTab;
    },

    emptyStateCompleteTab(): any {
      return {
        image: this.$t(
          `milestonePlanner.milestonePlan.completeView.emptyState.notCompleted.image`,
        ),
        title: this.$t(
          `milestonePlanner.milestonePlan.completeView.emptyState.notCompleted.title`,
        ),
        description: this.$t(
          `milestonePlanner.milestonePlan.completeView.emptyState.notCompleted.description`,
          {
            company: this.ownerName,
          },
        ),
      };
    },

    emptyStatePlanTab(): any {
      return !this.isMilestonePlanned
        ? {
            image: this.$t(
              `milestonePlanner.milestonePlan.planView.emptyState.noPlan.image`,
            ),
            title: this.$t(
              `milestonePlanner.milestonePlan.planView.emptyState.noPlan.title`,
            ),
            description: this.$t(
              `milestonePlanner.milestonePlan.planView.emptyState.noPlan.description`,
              {
                company: this.ownerName,
              },
            ),
          }
        : {
            image: this.$t(
              `milestonePlanner.milestonePlan.planView.emptyState.noDraftAccess.image`,
            ),
            title: this.$t(
              `milestonePlanner.milestonePlan.planView.emptyState.noDraftAccess.title`,
              {
                company: this.ownerName,
              },
            ),
            description: this.$t(
              `milestonePlanner.milestonePlan.planView.emptyState.noDraftAccess.description`,
              {
                company: this.ownerName,
              },
            ),
          };
    },

    /**
     * TEMP: Only show first question, while most common questions is pending specification.
     */
    evidenceQuestions(): Array<IMatchingQuestion> {
      return this.questions.length ? [this.questions[0]] : [];
    },

    formEvidenceQuestion(): string {
      return this.evidenceQuestions.length
        ? this.evidenceQuestions[0]?.entrepreneur_question
        : "";
    },
  },

  watch: {
    milestone: {
      deep: true,
      immediate: true,
      handler(newValue: IMilestone | null) {
        if (newValue) {
          const milestoneToFormValues = this.formatMilestoneValues(newValue);
          const prefillValues = mapKeys(milestoneToFormValues, (v, k) =>
            camelCase(k),
          );
          (this as any).planForm = pick(
            prefillValues,
            Object.keys(this.planInitialState),
          );
          (this as any).completeForm = pick(
            prefillValues,
            Object.keys(this.evidenceInitialState),
          );
        } else {
          this.planForm = { ...this.planInitialState };
          this.completeForm = { ...this.evidenceInitialState };
        }
      },
    },
  },

  methods: {
    formatMilestoneValues(milestone: IMilestone) {
      const targetDate = milestone.target_date
        ? moment(milestone.target_date).format("MMMM D, YYYY")
        : null;
      const financesNeeded = !isNaN(String(milestone.finances_needed) as any)
        ? `$ ${(
            parseInt(String(milestone.finances_needed)) as number
          ).toLocaleString()}`
        : "";
      const evidence = milestone.evidence[0]?.value?.text || "";
      const dateOfCompletion = milestone.date_of_completion
        ? moment(milestone.date_of_completion).format("MMMM D, YYYY")
        : null;

      return {
        ...milestone,
        targetDate,
        financesNeeded,
        evidence,
        dateOfCompletion,
      };
    },
  },
});
